import React, { ReactNode } from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'text-foreground' : 'bg-gray-50 text-gray-900'}`}>
      {/* Aqui você pode adicionar um cabeçalho, barra lateral, etc. */}
      <main className="pb-8">
        {children}
      </main>
      {/* Aqui você pode adicionar um rodapé, se necessário */}
    </div>
  );
};

export default MainLayout; 